module.exports = __webpack_public_path__ + "iPhone7-RoseGold.png?aa72bff2cb99d21aa4c2a5da5cd8b62f";